import * as React from 'react'
import { GridColumnVisibilityModel } from '@mui/x-data-grid-pro'
import { ActionMenu } from '@user/components/Settings/SCWebhooks/ActionMenu'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import { SalesCenterWebhook } from '@user/store/scWebHooks'

interface Props {
  handleEditClick?: (webhook: SalesCenterWebhook) => void
  handleDeleteRequest?: (webhookId: number) => void
  onChangeStatus?: (webhook: SalesCenterWebhook) => void
  tidalThemeActive?: boolean
}

export const webhookListColumns = ({
  handleEditClick,
  handleDeleteRequest,
  onChangeStatus,
  tidalThemeActive,
}: Props) => {
  return [
    {
      width: 50,
      type: 'actions',
      field: 'actions',
      headerName: 'Actions',
      renderHeader: () => null,
      sortable: false,
      resizable: false,
      filterable: false,
      disableReorder: true,
      disableColumnMenu: true,
      renderCell: ({ row }) =>
        handleEditClick &&
        handleDeleteRequest && (
          <ActionMenu
            webhook={row}
            handleEditClick={handleEditClick}
            handleDeleteRequest={handleDeleteRequest}
          />
        ),
    },
    {
      field: 'status',
      headerName: 'Status',
      disableReorder: true,
      sortable: false,
      minWidth: 145,
      renderCell: ({ row }) => (
        <FormControlLabel
          sx={{
            fontWeight: tidalThemeActive ? 'bold' : '',
            marginBottom: 0,
            gap: (theme) => theme.spacing(0.8),
          }}
          labelPlacement="end"
          label={row.isEnabled ? 'Active' : 'Inactive'}
          control={
            <Switch
              size={'small'}
              checked={row.isEnabled}
              onChange={() => {
                onChangeStatus && onChangeStatus(row)
              }}
            />
          }
        />
      ),
    },
    {
      field: 'createdTime',
      headerName: 'Created Date',
      type: 'date',
    },
    {
      field: 'endpointUrl',
      headerName: 'Webhook URL',
    },
    {
      field: 'webhookType',
      headerName: 'Webhook Type',
      sortable: false,
    },
    {
      field: 'entityType',
      headerName: 'Record Type',
      sortable: false,
      valueGetter: ({ row }) =>
        row.entityType === 'Any' ? 'Lead, Opportunity' : row.entityType,
    },
    {
      field: 'email',
      headerName: 'Notify',
    },
    {
      field: 'customHeaderValues',
      headerName: 'Custom Header Value',
      sortable: false,
      renderCell: ({ row }) => {
        return row.customHeaderValues?.map((header, index) => (
          <span key={index}>
            {header.key} {header.value}
            {index < row.customHeaderValues.length - 1 && `,`}&nbsp;
          </span>
        ))
      },
    },
  ]
}

export const defaultColVis = webhookListColumns(
  {},
).reduce<GridColumnVisibilityModel>((acc, { field }) => {
  if (acc[field] === undefined) {
    return { ...acc, [field]: true }
  } else return acc
}, {})

export const defaultColumns = webhookListColumns({}).map((c) => c.field)
